import { LoadState } from "../../constants/enum";
import { ICommonState } from "./common.types";



export const defaultCommonState: ICommonState = {
    errorVisible: null,
    snackbarVisible: null,
    loader_with_message: {
        loading: false,
    },
    modules: {
        tableNames: {
          data: [],
          loading: LoadState.idle,
        },
        tableViews: {
          data: [],
          loading: LoadState.idle,
        },
      },
      endPointsByModule: {
        data: {},
        loading: LoadState.idle,
      },
}